const es = {
  // Navigation
  skipToContent: 'Saltar al contenido',
  navHome: 'Inicio',
  navProperties: 'Propiedades',
  menuBuy: 'Comprar',
  menuRent: 'Alquilar',
  navAbout: 'Nosotros',
  navContact: 'Contacto',
  navCta: 'Hablar con un asesor',
  menuLabel: 'Menú',
  menuOpen: 'Abrir menú',
  menuClose: 'Cerrar menú',
  themeToggleToDark: 'Activar modo oscuro',
  themeToggleToLight: 'Activar modo claro',
  languageLabel: 'Idioma',
  navMainLabel: 'Navegación principal',
  navMobileLabel: 'Menú',
  breadcrumbLabel: 'Ruta de navegación',
  light: 'Claro',
  dark: 'Oscuro',

  // Operations & features
  sale: 'Venta',
  rent: 'Alquiler',
  onSale: 'En venta',
  forRent: 'En alquiler',
  allOperations: 'Todas',
  roomsShort: 'amb.',
  bedroomsShort: 'dorm.',
  bathroomsShort: 'baños',
  rooms: 'ambientes',
  bedrooms: 'dormitorios',
  bathrooms: 'baños',
  garage: 'Cochera',
  yes: 'con',
  no: 'sin',
  totalArea: 'm² totales',
  coveredArea: 'm² cubiertos',
  coveredAreaShort: 'm² cub.',
  yearsOld: 'años de antigüedad',
  highlight: 'destacado',
  dimensions: 'Frente × fondo',
  pricePerM2: 'Precio por m²',
  perM2: '/m²',
  servicesTitle: 'Servicios',
  services: {
    agua: 'Agua corriente',
    luz: 'Luz eléctrica',
    gas: 'Gas natural',
    cloacas: 'Cloacas',
    asfalto: 'Calle asfaltada',
  },
  deedLabel: 'Documentación',
  deeds: {
    escritura: 'Escritura',
    boleto: 'Boleto de compraventa',
    posesion: 'Posesión',
    tramite: 'Escritura en trámite',
  },
  directions: 'Cómo llegar',

  // Land pages
  navLand: 'Terrenos',
  landTitle: 'Terrenos en venta en Tucumán',
  landTitleCity: 'Terrenos en venta en {city}',
  landLead: 'Lotes con medidas, servicios disponibles, precio por m² y ubicación exacta en el mapa.',
  landSeoDescription: 'Terrenos y lotes en venta en Tucumán con medidas, servicios, precio por m² y ubicación en el mapa. Consultá directo por WhatsApp con FoxInmo.',
  landSeoDescriptionCity: 'Terrenos y lotes en venta en {city} con medidas, servicios, precio por m² y ubicación en el mapa. Consultá directo por WhatsApp con FoxInmo.',
  landZones: 'Zonas',
  landAllZones: 'Todas',
  landCountOne: '{n} terreno',
  landCountOther: '{n} terrenos',
  landEmpty: 'Por ahora no hay terrenos publicados en esta zona.',
  landEmptyCta: 'Ver todos los terrenos',
  waLandMessage: 'Hola, estoy buscando un terreno{city}. ¿Me pueden ayudar?',
  waLandCity: ' en {city}',

  // Hero & search
  heroEyebrow: 'Asesores en propiedades · Tucumán, Argentina',
  heroLines: ['Terrenos en Tucumán', 'para construir', { text: 'o invertir.', accent: true }],
  heroLead: 'Lotes con medidas, servicios y ubicación exacta, y también casas y departamentos. Te asesoramos y acompañamos desde la primera consulta.',
  heroAvailableOne: '{n} propiedad disponible',
  heroAvailableOther: '{n} propiedades disponibles',
  heroPrev: 'Propiedad anterior',
  heroNext: 'Propiedad siguiente',
  heroSlideLabel: 'Propiedad {n} de {total}',
  heroFallback: 'Nuevas propiedades muy pronto.',
  searchTitle: 'Buscar propiedades',
  searchOperation: 'Operación',
  searchType: 'Tipo',
  searchLocation: 'Ubicación',
  searchLocationPlaceholder: 'Escribí una ciudad',
  searchMaxPrice: 'Precio hasta',
  searchAnyPrice: 'Sin límite',
  searchSubmit: 'Buscar',
  allPropertyTypes: 'Todos los tipos',
  allCities: 'Todas las ciudades',
  searchCity: 'Buscar ciudad',
  clearCity: 'Limpiar ciudad',

  // Home sections
  latestEyebrow: 'Recién publicadas',
  latestLines: ['Lo último que', { text: 'sumamos a la cartera.', accent: true }],
  latestLead: 'Cada ficha tiene fotos, medidas, servicios, ubicación exacta y contacto directo para coordinar una visita.',
  latestViewAllOne: 'Ver la propiedad',
  latestViewAllOther: 'Ver las {n} propiedades',
  featuredEyebrow: 'Destacada',
  featuredCta: 'Ver propiedad',
  featuredInquiry: 'Consultar disponibilidad',
  operationsEyebrow: '¿Qué estás buscando?',
  saleCountOne: '{n} propiedad en venta',
  saleCountOther: '{n} propiedades en venta',
  rentCountOne: '{n} propiedad en alquiler',
  rentCountOther: '{n} propiedades en alquiler',
  operationEmpty: 'Consultanos por nuevas opciones',
  aboutEyebrow: 'Quiénes somos',
  aboutLines: ['Somos', { text: 'FoxInmo.', accent: true }],
  aboutHuman: 'Trabajamos de forma personal: quien te muestra la propiedad es quien responde tus consultas y te orienta en cada paso.',
  aboutPhotoCaption: 'En la imagen: {title}, {city}.',
  statProperties: 'propiedades publicadas',
  statCities: 'ciudades',
  statAdvisors: 'asesores dedicados',
  processEyebrow: 'Cómo trabajamos',
  processSteps: [
    {
      title: 'Precio de referencia y estrategia',
      text: 'Comparamos propiedades similares para orientarte sobre un precio de publicación y definimos cómo presentarla para llegar a los interesados correctos.',
    },
    {
      title: 'Publicación y visitas',
      text: 'Fotos, descripción y ficha técnica completas. Coordinamos cada visita y respondemos las consultas de manera directa.',
    },
    {
      title: 'Documentación y acompañamiento',
      text: 'Te orientamos con la documentación necesaria y te acompañamos hasta que la operación se formaliza con los profesionales que correspondan.',
    },
  ],
  aboutMore: 'Conocé al equipo',
  citiesEyebrow: 'Dónde',
  citiesTitle: 'Propiedades por ciudad',
  cityCountOne: '{n} propiedad',
  cityCountOther: '{n} propiedades',

  // Sell
  sellKicker: 'Publicá con nosotros',
  sellTitle: '¿Querés vender tu propiedad?',
  sellSubtitle: 'Te ayudamos a definir un precio de referencia, publicar y difundir tu propiedad con asesoramiento personalizado.',
  sellWhatsapp: 'Hablar por WhatsApp',
  sellEmail: 'Enviar correo',
  sellFormTitle: 'Contanos sobre tu propiedad',
  sellMessagePlaceholder: 'Ejemplo: casa de 4 ambientes con jardín, lista para publicar.',
  sellSubmit: 'Quiero que me contacten',
  sellFormNote: 'Al enviar se abre WhatsApp con tu mensaje listo.',
  waSellIntro: 'Hola, quiero vender mi propiedad.',
  waSellName: ' Mi nombre es {value}.',
  waSellPhone: ' Mi teléfono es {value}.',
  waSellCity: ' Está en {value}.',

  // FAQ & guide
  faqEyebrow: 'Antes de decidir',
  faqTitle: 'Preguntas frecuentes antes de elegir una propiedad',
  faqItems: [
    {
      q: '¿Cómo sé si el precio publicado es razonable?',
      a: 'Compará propiedades similares por zona, metros, estado y prestaciones. Un valor razonable suele aparecer cuando varios avisos comparables coinciden en un rango y cuando la información legal y técnica es clara.',
    },
    {
      q: '¿Qué conviene revisar antes de reservar?',
      a: 'Verificá documentación de dominio, situación impositiva, expensas, estado de servicios y condiciones contractuales. Revisar estos puntos antes de reservar reduce riesgos y evita demoras al momento de firmar.',
    },
    {
      q: '¿Qué características tiene una publicación de calidad?',
      a: 'Una buena publicación incluye medidas precisas, fotos reales, ubicación clara, precio actualizado y vías de contacto transparentes. Cuanto mejor es la calidad de datos, mejores son las consultas y las decisiones.',
    },
  ],
  guideTitle: 'Guía para comprar, alquilar y vender propiedades en Argentina',
  guideToggleOpen: 'Leer la guía completa',
  guideToggleClose: 'Cerrar la guía',
  guideParagraphs: [
    'Comprar una propiedad requiere planificación clara. Definí con anticipación tus ahorros disponibles, ingresos mensuales y alternativas de financiación antes de visitar inmuebles. Este primer paso te permite evaluar oportunidades con criterios realistas y evita frustraciones durante la negociación. En FoxInmo, cada publicación está organizada para comparar tamaño, ubicación, estado y precio de forma práctica.',
    'Si estás buscando alquiler, priorizá la dinámica del barrio, el acceso al transporte, el nivel de expensas y las condiciones del contrato. Un alquiler mensual más bajo no siempre es la opción más conveniente cuando los costos adicionales son altos o la ubicación complica tu rutina. Analizar la información completa de cada aviso mejora la calidad de decisión.',
    'Para propietarios que desean vender, un precio bien definido y una presentación profesional son claves. Fotos de buena calidad, descripciones bien redactadas y datos técnicos completos elevan la calidad de consultas y acortan los tiempos de venta. Publicar con estrategia suele generar mejores visitas y mejores ofertas que publicar sin estructura.',
    'La búsqueda con mapa aporta contexto geográfico real: accesos, colegios, zonas comerciales, parques y servicios cercanos. Dos propiedades con precio similar pueden ofrecer experiencias muy distintas según su entorno urbano y conectividad. Comparar inmuebles por ubicación ayuda a detectar oportunidades que no se ven solo con fotos.',
    'Durante las visitas, verificá aspectos legales y técnicos: situación dominial, impuestos, expensas, estado de instalaciones, calidad constructiva e historial de mejoras. Registrar observaciones después de cada recorrido permite comparar con objetividad. La mayoría de las decisiones sólidas combinan percepción del espacio con documentación verificable.',
    'Las operaciones exitosas se apoyan en comunicación transparente, información completa y tiempos ordenados. Ya sea que quieras comprar, alquilar o vender, en FoxInmo centralizamos los datos relevantes y facilitamos el contacto directo. Así, cada etapa de la operación avanza con mayor claridad, menos fricción y mejores resultados finales.',
  ],

  // Final CTA
  ctaEyebrow: 'Hablemos',
  ctaLines: ['¿Viste una propiedad', { text: 'que te interesa?', accent: true }],
  ctaLead: 'Escribinos y coordinamos una visita. Te atendemos por WhatsApp, teléfono o email.',
  ctaWhatsapp: 'Escribir por WhatsApp',
  ctaCall: 'Llamar',
  ctaEmail: 'Enviar un email',
  ctaContactPage: 'Todas las formas de contacto',
  waGeneralMessage: 'Hola, quiero hablar con un asesor de FoxInmo.',

  // Listing
  listingEyebrow: 'Propiedades',
  listingTitleAll: 'Propiedades en venta y alquiler',
  listingTitleSale: 'Propiedades en venta',
  listingTitleRent: 'Propiedades en alquiler',
  listingLead: 'Filtrá por operación, tipo, ciudad, precio y características para encontrar la tuya.',
  resultsOne: '{n} propiedad',
  resultsOther: '{n} propiedades',
  filtersTitle: 'Filtros',
  moreFilters: 'Más filtros',
  minPrice: 'Precio mínimo',
  maxPrice: 'Precio máximo',
  maxArea: 'Superficie máxima',
  bedroomsFilter: 'Dormitorios',
  bathroomsFilter: 'Baños',
  minArea: 'Superficie mínima',
  anyOption: 'Indistinto',
  sortLabel: 'Ordenar por',
  sortRecent: 'Más recientes',
  sortPriceAsc: 'Menor precio',
  sortPriceDesc: 'Mayor precio',
  sortAreaDesc: 'Mayor superficie',
  clearFilters: 'Limpiar filtros',
  applyFilters: 'Ver resultados',
  removeFilter: 'Quitar filtro: {label}',
  viewMap: 'Mapa',
  viewList: 'Listado',
  viewModeLabel: 'Modo de vista',
  mapNoCoords: 'Ninguna de estas propiedades tiene ubicación cargada en el mapa.',
  emptyTitle: 'No encontramos propiedades con estos criterios.',
  emptyText: 'Probá ampliar el rango de precio o quitar algún filtro. También podés contarnos qué buscás y te avisamos cuando ingrese algo así.',
  emptyCta: 'Contanos qué buscás',
  waSearchMessage: 'Hola, estoy buscando una propiedad y no encontré lo que necesito en la web.',
  loadMore: 'Ver más propiedades',
  showingOf: 'Mostrando {shown} de {total}',
  listingHelpTitle: '¿No encontrás lo que buscás?',
  listingHelpText: 'Contanos qué necesitás y te avisamos cuando ingrese una propiedad así.',
  loading: 'Cargando propiedades...',
  loadError: 'No pudimos cargar las propiedades en este momento. Probá de nuevo en unos minutos.',
  retry: 'Reintentar',
  noResults: 'No hay resultados para los filtros seleccionados.',
  propertiesFound: 'propiedades encontradas',
  viewDetail: 'Ver propiedad',
  prevPage: 'Anterior',
  nextPage: 'Siguiente',
  page: 'Página',

  // Card
  viewProperty: 'Ver propiedad',
  inquire: 'Consultar',
  inquireAbout: 'Consultar por WhatsApp sobre {title}',
  photoMissing: 'Sin fotografía',
  contact: 'Contactar',

  // Detail
  backToList: 'Volver al listado',
  photosCount: '{n} fotos',
  viewAllPhotos: 'Ver las {n} fotos',
  openGallery: 'Abrir galería a pantalla completa',
  expandPhoto: 'Ampliar',
  prevPhoto: 'Foto anterior',
  nextPhoto: 'Foto siguiente',
  closeGallery: 'Cerrar galería',
  photoOf: 'Foto {n} de {total}',
  expenses: 'Expensas',
  inCity: 'en {city}',
  readMore: 'Leer más',
  readLess: 'Leer menos',
  keyFacts: 'Características principales',
  description: 'Descripción',
  moreAboutProperty: 'Comodidades y detalles',
  technicalSheet: 'Ficha técnica',
  propertyType: 'Tipo de propiedad',
  operation: 'Operación',
  address: 'Dirección',
  city: 'Ciudad',
  province: 'Provincia',
  postalCode: 'Código postal',
  price: 'Precio',
  locationMap: 'Ubicación',
  contactAdvertiser: 'Consultá por esta propiedad',
  contactLead: 'Escribinos por WhatsApp o dejanos tus datos y te contactamos para coordinar.',
  ctaWhatsappProperty: 'Consultar por WhatsApp',
  ctaVisit: 'Quiero visitarla',
  ctaVisitShort: 'Agendar visita',
  formTitle: 'O dejanos tu consulta',
  name: 'Nombre',
  email: 'Correo',
  phone: 'Teléfono',
  message: 'Mensaje',
  messageDefault: 'Hola, me interesa esta propiedad y quisiera más información.',
  send: 'Enviar consulta',
  sending: 'Enviando...',
  messageSent: 'Recibimos tu consulta. Te vamos a contactar pronto.',
  sendError: 'No pudimos enviar la consulta. Probá de nuevo o escribinos por WhatsApp.',
  similarTitle: 'También te puede interesar',
  notFoundTitle: 'Esta propiedad ya no está disponible',
  notFoundText: 'Puede que se haya vendido, alquilado o que el enlace haya cambiado. Mirá otras opciones disponibles.',
  notFoundCta: 'Ver propiedades disponibles',
  share: 'Compartir',
  linkCopied: 'Enlace copiado',
  callUs: 'Llamar',
  waPropertyMessage: 'Hola, me interesa la propiedad "{title}" en {city}. {url}',
  waVisitMessage: 'Hola, quiero coordinar una visita a la propiedad "{title}" en {city}. {url}',

  // Contact page
  contactEyebrow: 'Contacto',
  contactLines: ['Hablemos de', { text: 'tu próxima propiedad.', accent: true }],
  contactPageLead: 'Para comprar, alquilar, vender o consultar un precio de referencia. Escribinos por el canal que prefieras.',
  channelWhatsapp: 'WhatsApp',
  channelPhone: 'Teléfono',
  channelEmail: 'Email',
  channelArea: 'Zona',
  contactFormTitle: 'Contanos qué necesitás',
  contactReason: 'Motivo',
  reasonBuy: 'Quiero comprar',
  reasonRent: 'Quiero alquilar',
  reasonSell: 'Quiero vender',
  reasonAppraise: 'Quiero un precio de referencia',
  contactSubmit: 'Enviar por WhatsApp',
  waContactIntro: 'Hola, soy {name}.',

  // About page
  aboutTitle: 'Quiénes somos',
  aboutIntro: 'Somos dos asesores en propiedades: difundimos terrenos y propiedades, respondemos cada consulta y acompañamos a las personas con información clara y trato directo.',
  aboutRole: 'Asesor en propiedades',
  aboutCardOne: 'Especialista en captación, precios de referencia y estrategia de publicación.',
  aboutCardTwo: 'Especialista en atención de consultas, visitas y acompañamiento durante todo el proceso.',
  aboutPageLines: ['Asesores', { text: 'con nombre y apellido.', accent: true }],
  aboutTeamTitle: 'El equipo',

  // Footer
  footerStatement: 'Propiedades en venta y alquiler, con atención personal de principio a fin.',
  footerTagline: 'Asesoramiento para comprar, alquilar y vender, con acompañamiento personal.',
  footerBackTop: 'Volver arriba',
  footerCopy: 'FoxInmo. Todos los derechos reservados.',
  footerSectionExplore: 'Explorar',
  footerSectionCompany: 'Empresa',
  footerSectionContact: 'Contacto',
  footerAbout: 'Quiénes somos',
  footerPrivacy: 'Política de privacidad',
  footerTerms: 'Términos y condiciones',
  footerBuyLink: 'Propiedades en venta',
  footerRentLink: 'Propiedades en alquiler',
  footerSell: 'Vender mi propiedad',
  footerShareTitle: 'Compartir',
  footerCity: 'Tucumán, Argentina',

  // Legal
  privacyTitle: 'Política de privacidad',
  privacyIntro: 'En FoxInmo cuidamos tus datos personales y solo los usamos para responder consultas sobre propiedades y mejorar la atención.',
  privacyDataTitle: 'Datos que recopilamos',
  privacyDataText: 'Podemos recopilar nombre, correo, teléfono y mensaje cuando completás formularios de contacto o venta.',
  privacyUseTitle: 'Cómo usamos la información',
  privacyUseText: 'Usamos tus datos para responderte, coordinar visitas, enviar propuestas y hacer seguimiento comercial.',
  privacyRightsTitle: 'Tus derechos',
  privacyRightsText: 'Podés solicitar la actualización o eliminación de tus datos escribiéndonos por email.',
  termsTitle: 'Términos y condiciones',
  termsIntro: 'Al usar este sitio aceptás las siguientes condiciones de uso para navegación, consultas y publicaciones.',
  termsScopeTitle: 'Alcance del servicio',
  termsScopeText: 'FoxInmo brinda asesoramiento y difusión de propiedades y facilita el contacto entre las partes. No es una inmobiliaria ni presta servicios de corretaje inmobiliario: cada operación se formaliza directamente entre las partes, con los profesionales matriculados que correspondan.',
  termsAccuracyTitle: 'Exactitud de la información',
  termsAccuracyText: 'Intentamos mantener los datos actualizados, aunque pueden existir cambios de precio, disponibilidad o condiciones.',
  termsLiabilityTitle: 'Responsabilidad',
  termsLiabilityText: 'FoxInmo no se responsabiliza por decisiones tomadas sin verificación documental previa de las partes.',
  legalUpdated: 'Información legal',

  // SEO
  seoHomeTitle: 'Terrenos y propiedades en venta en Tucumán',
  seoHomeDescription: 'Terrenos y lotes en venta en Tucumán con medidas, servicios, precio por m² y ubicación en el mapa. También casas y departamentos. Contacto directo con FoxInmo.',
  seoContactDescription: 'Contactá a FoxInmo por WhatsApp, teléfono o email para comprar, alquilar o vender tu propiedad.',

  // Admin (unchanged behavior)
  publish: 'Publicar',
  adminPanel: 'Panel admin',
  login: 'Ingresar',
  invalidAdminKey: 'ADMIN_KEY inválida o faltante',
  invalidAdminCredentials: 'Usuario o clave de admin inválidos',
  adminTitle: 'Panel administrador',
  adminUsername: 'Usuario admin',
  adminPassword: 'Clave admin',
  enterAdmin: 'Ingresar al panel',
  adminSessionUser: 'Sesión iniciada',
  logout: 'Cerrar sesión',
  editProperty: 'Editar propiedad',
  newProperty: 'Nueva propiedad',
  propertyTitle: 'Título',
  propertyDescription: 'Descripción',
  imageUrl: 'URL imagen principal',
  actions: 'Acciones',
  edit: 'Editar',
  delete: 'Eliminar',
  confirmDelete: '¿Deseás dar de baja esta propiedad?',
  saveChanges: 'Guardar cambios',
  createProperty: 'Crear propiedad',
  adminImageListHint: 'URLs de fotos (una por línea o separadas por coma)',
  adminImagePreviewTitle: 'Vista previa de fotos',
  adminMainImageTag: 'Principal',
  adminImageTag: 'Foto',
  adminNoImagesPreview: 'Agregá URLs para previsualizar imágenes antes de guardar.',
  adminRoomsHint: 'Ambientes: colocá la cantidad total de ambientes (ejemplo: 3 o 4).',
  adminAgeHint: 'Antigüedad: colocá los años aproximados de la propiedad.',
  adminUploadImages: 'Subir fotos desde tu dispositivo',
  adminUploadingImages: 'Subiendo imágenes...',
  adminUploadError: 'No se pudieron subir las imágenes seleccionadas.',
  adminOptionalField: 'Campo opcional',
  adminGarageYes: 'Con cochera',
  adminGarageNo: 'Sin cochera',
  adminAmenitiesHint: 'Detalles extra o amenidades (una por línea o separadas por coma)',
  adminDetailsTitle: 'Detalles de la propiedad',
  adminAddDetail: 'Agregar detalle',
  adminDetailValue: 'Valor del detalle (ej: 80, 3, Sí, Balcón)',
  adminDetailType_SuperficieM2: 'm² totales',
  adminDetailType_SuperficieCubiertaM2: 'm² cubiertos',
  adminDetailType_Ambientes: 'ambientes',
  adminDetailType_Dormitorios: 'dormitorios',
  adminDetailType_Banios: 'baños',
  adminDetailType_Antiguedad: 'antigüedad (años)',
  adminDetailType_Cochera: 'cochera (Sí/No)',
  adminDetailType_Amenidad: 'detalle destacado',
  adminRemoveDetail: 'Quitar',
  adminInquiriesTitle: 'Consultas de clientes',
  adminInquiryProperty: 'Propiedad',
  adminInquiryContact: 'Contacto',
  adminInquiryMessage: 'Mensaje',
  adminInquiryStatus: 'Estado',
  adminInquiryDate: 'Fecha',
  adminNoInquiries: 'Todavía no hay consultas registradas.',
  adminFeaturedLabel: 'Destacar en portada',
  adminFeaturedHint: 'Hasta 4 destacadas: van primero en el carrusel de la portada y la última que marques ocupa también el bloque grande. Si hay menos de 4, el carrusel se completa con las más nuevas.',
  adminFeaturedTag: 'Destacada',
  adminLandTitle: 'Terreno y servicios',
  adminFrente: 'Frente (m)',
  adminFondo: 'Fondo (m)',
  adminDeedNone: 'Documentación: sin especificar',

  // El Molino del Churqui
  navProject: 'El Molino',
  projectBadge: 'Proyecto destacado',
  projectTagline: 'Invertir en El Churqui es pensar a largo plazo.',
  projectSpotlightLead: 'Lotes en Tafí del Valle, a 5 minutos del centro, con vistas panorámicas de 360° y conexión directa al circuito deportivo El Churqui.',
  projectCta: 'Conocer el proyecto',
  projectInquire: 'Consultar por lotes',
  projectViewPlan: 'Ver plano de lotes',
  projectBlocksLabel: 'manzanas',
  projectLotSizesLabel: 'superficie de los lotes',
  projectCenterLabel: 'del centro de Tafí',
  projectViewsLabel: 'vistas panorámicas',
  projectAreaRange: '{min} a {max} m²',
  projectAboutTitle: 'Sobre el proyecto',
  projectAboutText: 'El Molino del Churqui es un emprendimiento ubicado en Tafí del Valle, Tucumán, pensado para personas que aprecian el confort y desean conectarse con la naturaleza.',
  projectAboutText2: 'Un lugar donde la modernidad y la tradición se entrelazan, y donde la exclusividad y la conexión con la tierra se presentan como una excelente posibilidad de inversión.',
  projectQuote: 'Soñar es el primer paso. Tenerlo, el siguiente.',
  projectHighlightsTitle: 'Por qué El Molino',
  projectHighlights: [
    { icon: 'clock', title: 'A 5 minutos del centro', text: 'Ubicación privilegiada, cerca de todo lo que ofrece Tafí del Valle.' },
    { icon: 'mountain', title: 'Vistas panorámicas 360°', text: 'Vistas abiertas a los cerros y al valle de Tafí.' },
    { icon: 'asfalto', title: 'Por Ruta 307', text: 'Se llega por la ruta 307, la que sube a Tafí del Valle desde San Miguel de Tucumán.' },
    { icon: 'loop', title: 'Circuito deportivo El Churqui', text: 'Conexión directa con el circuito, para hacer deporte al aire libre.' },
    { icon: 'tree', title: 'Parque lineal', text: 'Un parque lineal acompaña el borde del loteo.' },
    { icon: 'store', title: 'Centro comercial «El Molino»', text: 'El plan del emprendimiento incluye un sector propio para el centro comercial.' },
  ],
  projectLotsTitle: 'Plano de lotes',
  projectLotsLead: 'Tocá una manzana para ver la superficie de sus lotes y consultar disponibilidad. Los colores indican el sector.',
  projectSectors: {
    alto: 'Sector Alto',
    central: 'Sector Central',
    lateral: 'Sector Lateral',
    comercial: 'Sector Centro Comercial',
  },
  projectSoldLegend: 'Lotes rayados: vendidos',
  projectBlock: 'Manzana {id}',
  projectBlockArea: 'Lotes de {min} a {max} m²',
  projectBlockInquire: 'Consultar',
  projectBlockAria: 'Manzana {id}, lotes de {min} a {max} m²',
  projectLotsNote: 'Superficies informadas por el emprendimiento. Precio y disponibilidad de cada lote, a confirmar por WhatsApp.',
  projectVideosTitle: 'Videos del proyecto',
  projectVideosLead: 'Recorré el lugar y conocé cómo se proyecta el centro comercial del emprendimiento.',
  projectVideos: {
    project: 'El Molino del Churqui en Tafí del Valle',
    commercial: 'Centro comercial «El Molino» (imágenes ilustrativas del proyecto)',
  },
  projectGalleryTitle: 'Fotos y plano',
  projectLocationTitle: 'Ubicación',
  projectViewOnMaps: 'Ver en Google Maps',
  projectInstagram: 'Seguí el proyecto en Instagram',
  projectCtaLines: ['¿Te interesa un lote', { text: 'en El Molino?', accent: true }],
  projectCtaLead: 'Escribinos y te contamos qué lotes quedan disponibles, precios y cómo coordinar una visita a Tafí del Valle.',
  projectWaMessage: 'Hola, quiero información sobre los lotes de El Molino del Churqui en Tafí del Valle.',
  projectWaBlockMessage: 'Hola, quiero consultar por los lotes de la Manzana {id} de El Molino del Churqui (de {min} a {max} m²). ¿Qué disponibilidad y precios tienen?',
  projectSeoTitle: 'El Molino del Churqui — Lotes en Tafí del Valle',
  projectSeoDescription: 'Lotes en venta en El Molino del Churqui, Tafí del Valle, Tucumán: 11 manzanas, lotes de 808 a 3.993 m², a 5 minutos del centro y con vistas 360°. Consultá por WhatsApp.',
};

const en = {
  skipToContent: 'Skip to content',
  navHome: 'Home',
  navProperties: 'Properties',
  menuBuy: 'Buy',
  menuRent: 'Rent',
  navAbout: 'About',
  navContact: 'Contact',
  navCta: 'Talk to an advisor',
  menuLabel: 'Menu',
  menuOpen: 'Open menu',
  menuClose: 'Close menu',
  themeToggleToDark: 'Switch to dark mode',
  themeToggleToLight: 'Switch to light mode',
  languageLabel: 'Language',
  navMainLabel: 'Main navigation',
  navMobileLabel: 'Menu',
  breadcrumbLabel: 'Breadcrumb',
  light: 'Light',
  dark: 'Dark',

  sale: 'Sale',
  rent: 'Rent',
  onSale: 'For sale',
  forRent: 'For rent',
  allOperations: 'All',
  roomsShort: 'rooms',
  bedroomsShort: 'beds',
  bathroomsShort: 'baths',
  rooms: 'rooms',
  bedrooms: 'bedrooms',
  bathrooms: 'bathrooms',
  garage: 'Garage',
  yes: 'with',
  no: 'without',
  totalArea: 'total m²',
  coveredArea: 'covered m²',
  coveredAreaShort: 'covered m²',
  yearsOld: 'years old',
  highlight: 'highlight',
  dimensions: 'Frontage × depth',
  pricePerM2: 'Price per m²',
  perM2: '/m²',
  servicesTitle: 'Utilities',
  services: {
    agua: 'Running water',
    luz: 'Electricity',
    gas: 'Natural gas',
    cloacas: 'Sewage',
    asfalto: 'Paved street',
  },
  deedLabel: 'Title status',
  deeds: {
    escritura: 'Title deed',
    boleto: 'Purchase agreement',
    posesion: 'Possession',
    tramite: 'Deed in progress',
  },
  directions: 'Get directions',

  // Land pages
  navLand: 'Land',
  landTitle: 'Land for sale in Tucumán',
  landTitleCity: 'Land for sale in {city}',
  landLead: 'Plots with measurements, available utilities, price per m² and exact location on the map.',
  landSeoDescription: 'Land and plots for sale in Tucumán with measurements, utilities, price per m² and map location. Contact FoxInmo directly on WhatsApp.',
  landSeoDescriptionCity: 'Land and plots for sale in {city} with measurements, utilities, price per m² and map location. Contact FoxInmo directly on WhatsApp.',
  landZones: 'Areas',
  landAllZones: 'All',
  landCountOne: '{n} plot',
  landCountOther: '{n} plots',
  landEmpty: 'There are no plots listed in this area right now.',
  landEmptyCta: 'See all land',
  waLandMessage: 'Hi, I am looking for a plot of land{city}. Can you help me?',
  waLandCity: ' in {city}',

  heroEyebrow: 'Property advisors · Tucumán, Argentina',
  heroLines: ['Land in Tucumán', 'to build on', { text: 'or invest.', accent: true }],
  heroLead: 'Plots with measurements, utilities and exact location, plus houses and apartments. We advise and support you from your first inquiry.',
  heroAvailableOne: '{n} property available',
  heroAvailableOther: '{n} properties available',
  heroPrev: 'Previous property',
  heroNext: 'Next property',
  heroSlideLabel: 'Property {n} of {total}',
  heroFallback: 'New properties coming soon.',
  searchTitle: 'Search properties',
  searchOperation: 'Operation',
  searchType: 'Type',
  searchLocation: 'Location',
  searchLocationPlaceholder: 'Type a city',
  searchMaxPrice: 'Price up to',
  searchAnyPrice: 'No limit',
  searchSubmit: 'Search',
  allPropertyTypes: 'All property types',
  allCities: 'All cities',
  searchCity: 'Search city',
  clearCity: 'Clear city',

  latestEyebrow: 'Just listed',
  latestLines: ['The latest', { text: 'additions to our portfolio.', accent: true }],
  latestLead: 'Every listing includes photos, measurements, utilities, exact location and direct contact to schedule a visit.',
  latestViewAllOne: 'View the property',
  latestViewAllOther: 'View all {n} properties',
  featuredEyebrow: 'Featured',
  featuredCta: 'View property',
  featuredInquiry: 'Check availability',
  operationsEyebrow: 'What are you looking for?',
  saleCountOne: '{n} property for sale',
  saleCountOther: '{n} properties for sale',
  rentCountOne: '{n} property for rent',
  rentCountOther: '{n} properties for rent',
  operationEmpty: 'Ask us about new options',
  aboutEyebrow: 'About us',
  aboutLines: ['We are', { text: 'FoxInmo.', accent: true }],
  aboutHuman: 'We work personally: the person who shows you the property is the one who answers your questions and guides you at every step.',
  aboutPhotoCaption: 'Pictured: {title}, {city}.',
  statProperties: 'listed properties',
  statCities: 'cities',
  statAdvisors: 'dedicated advisors',
  processEyebrow: 'How we work',
  processSteps: [
    {
      title: 'Reference price and strategy',
      text: 'We compare similar properties to guide you on an asking price and define how to present it to reach the right people.',
    },
    {
      title: 'Listing and visits',
      text: 'Complete photos, description and technical data. We coordinate every visit and answer inquiries directly.',
    },
    {
      title: 'Paperwork and support',
      text: 'We guide you through the required documents and stay with you until the transaction is formalized with the appropriate professionals.',
    },
  ],
  aboutMore: 'Meet the team',
  citiesEyebrow: 'Where',
  citiesTitle: 'Properties by city',
  cityCountOne: '{n} property',
  cityCountOther: '{n} properties',

  sellKicker: 'List with us',
  sellTitle: 'Want to sell your property?',
  sellSubtitle: 'We help you set a reference price, publish and promote your property with personalized advice.',
  sellWhatsapp: 'Chat on WhatsApp',
  sellEmail: 'Send email',
  sellFormTitle: 'Tell us about your property',
  sellMessagePlaceholder: 'Example: 4-room house with garden, ready to list.',
  sellSubmit: 'Contact me',
  sellFormNote: 'Submitting opens WhatsApp with your message ready.',
  waSellIntro: 'Hi, I want to sell my property.',
  waSellName: ' My name is {value}.',
  waSellPhone: ' My phone is {value}.',
  waSellCity: ' It is located in {value}.',

  faqEyebrow: 'Before deciding',
  faqTitle: 'Frequently asked questions before choosing a property',
  faqItems: [
    {
      q: 'How do I know if the asking price is fair?',
      a: 'Compare similar properties by area, size, condition and amenities. A fair price usually appears when several comparable listings point to the same range and when legal and technical conditions are clear.',
    },
    {
      q: 'What should I verify before reserving a property?',
      a: 'Check ownership documentation, tax status, shared expenses, utility conditions and contract terms. Verification before reserving reduces legal risk and avoids delays in final signing.',
    },
    {
      q: 'What makes a listing high quality?',
      a: 'A strong listing includes accurate dimensions, realistic photos, clear location data, updated price and transparent contact methods. Better data quality produces better inquiries and better decisions.',
    },
  ],
  guideTitle: 'Guide to buying, renting and selling property in Argentina',
  guideToggleOpen: 'Read the full guide',
  guideToggleClose: 'Close the guide',
  guideParagraphs: [
    'Buying a property requires clear planning. Define your available savings, monthly income and financing alternatives before visiting homes. This first step helps you evaluate options with realistic criteria and prevents frustration during negotiations. At FoxInmo, each listing is structured to help you compare size, location, condition and price in a practical way.',
    'If you are looking for a rental, prioritize neighborhood dynamics, transport access, monthly expenses and contract terms. A lower monthly rent is not always the most convenient option if extra costs are high or if the location creates daily commuting problems. Reviewing complete listing information with context improves decision quality and reduces future surprises.',
    'For owners who want to sell, a well-defined price and high-quality presentation are essential. Professional photos, well-written descriptions and complete technical data increase lead quality and shorten selling times. An organized publication strategy can generate better visits and better negotiations than simply publishing without structure.',
    'Map-based search is useful because it adds real geographic context: access roads, schools, commercial areas, parks and service points nearby. Properties with similar prices may deliver very different lifestyle value depending on location and surrounding infrastructure. Comparing listings on a map helps identify hidden opportunities.',
    'During visits, confirm legal and technical details: title status, taxes, shared expenses, utility conditions, construction quality and renovation history. Taking notes after each visit allows objective comparison later. Buyers and tenants usually make stronger decisions when they combine emotional perception with verifiable documentation.',
    'A successful transaction usually comes from transparent communication, complete information and timing discipline. Whether you are buying, renting or selling, FoxInmo centralizes relevant property data and simplifies contact, so each step can move faster with fewer misunderstandings and better final outcomes.',
  ],

  ctaEyebrow: "Let's talk",
  ctaLines: ['Found a property', { text: 'you like?', accent: true }],
  ctaLead: 'Write to us and we will schedule a visit. Reach us on WhatsApp, by phone or email.',
  ctaWhatsapp: 'Message on WhatsApp',
  ctaCall: 'Call',
  ctaEmail: 'Send an email',
  ctaContactPage: 'All contact options',
  waGeneralMessage: 'Hi, I would like to talk to an advisor at FoxInmo.',

  listingEyebrow: 'Properties',
  listingTitleAll: 'Properties for sale and rent',
  listingTitleSale: 'Properties for sale',
  listingTitleRent: 'Properties for rent',
  listingLead: 'Filter by operation, type, city, price and features to find yours.',
  resultsOne: '{n} property',
  resultsOther: '{n} properties',
  filtersTitle: 'Filters',
  moreFilters: 'More filters',
  minPrice: 'Min price',
  maxPrice: 'Max price',
  maxArea: 'Maximum area',
  bedroomsFilter: 'Bedrooms',
  bathroomsFilter: 'Bathrooms',
  minArea: 'Minimum area',
  anyOption: 'Any',
  sortLabel: 'Sort by',
  sortRecent: 'Most recent',
  sortPriceAsc: 'Lowest price',
  sortPriceDesc: 'Highest price',
  sortAreaDesc: 'Largest area',
  clearFilters: 'Clear filters',
  applyFilters: 'Show results',
  removeFilter: 'Remove filter: {label}',
  viewMap: 'Map',
  viewList: 'List',
  viewModeLabel: 'View mode',
  mapNoCoords: 'None of these properties has a map location yet.',
  emptyTitle: 'We could not find properties matching these criteria.',
  emptyText: 'Try widening the price range or removing a filter. You can also tell us what you are looking for and we will let you know when something similar comes in.',
  emptyCta: 'Tell us what you need',
  waSearchMessage: 'Hi, I am looking for a property and could not find what I need on the website.',
  loadMore: 'Show more properties',
  showingOf: 'Showing {shown} of {total}',
  listingHelpTitle: 'Can’t find what you are looking for?',
  listingHelpText: 'Tell us what you need and we will let you know when a similar property comes in.',
  loading: 'Loading properties...',
  loadError: 'We could not load the properties right now. Please try again in a few minutes.',
  retry: 'Try again',
  noResults: 'No properties match your selected filters.',
  propertiesFound: 'properties found',
  viewDetail: 'View property',
  prevPage: 'Previous',
  nextPage: 'Next',
  page: 'Page',

  viewProperty: 'View property',
  inquire: 'Inquire',
  inquireAbout: 'Ask on WhatsApp about {title}',
  photoMissing: 'No photo',
  contact: 'Contact',

  backToList: 'Back to list',
  photosCount: '{n} photos',
  viewAllPhotos: 'View all {n} photos',
  openGallery: 'Open fullscreen gallery',
  expandPhoto: 'Expand',
  prevPhoto: 'Previous photo',
  nextPhoto: 'Next photo',
  closeGallery: 'Close gallery',
  photoOf: 'Photo {n} of {total}',
  expenses: 'Expenses',
  inCity: 'in {city}',
  readMore: 'Read more',
  readLess: 'Read less',
  keyFacts: 'Key features',
  description: 'Description',
  moreAboutProperty: 'Amenities and details',
  technicalSheet: 'Technical sheet',
  propertyType: 'Property type',
  operation: 'Operation',
  address: 'Address',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code',
  price: 'Price',
  locationMap: 'Location',
  contactAdvertiser: 'Ask about this property',
  contactLead: 'Message us on WhatsApp or leave your details and we will contact you to coordinate.',
  ctaWhatsappProperty: 'Ask on WhatsApp',
  ctaVisit: 'I want to visit',
  ctaVisitShort: 'Book a visit',
  formTitle: 'Or leave us a message',
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  message: 'Message',
  messageDefault: 'Hi, I am interested in this property and would like more information.',
  send: 'Send inquiry',
  sending: 'Sending...',
  messageSent: 'We received your inquiry. We will contact you soon.',
  sendError: 'We could not send your inquiry. Please try again or message us on WhatsApp.',
  similarTitle: 'You may also like',
  notFoundTitle: 'This property is no longer available',
  notFoundText: 'It may have been sold, rented, or the link may have changed. Take a look at other available options.',
  notFoundCta: 'View available properties',
  share: 'Share',
  linkCopied: 'Link copied',
  callUs: 'Call',
  waPropertyMessage: 'Hi, I am interested in the property "{title}" in {city}. {url}',
  waVisitMessage: 'Hi, I would like to schedule a visit to the property "{title}" in {city}. {url}',

  contactEyebrow: 'Contact',
  contactLines: ["Let's talk about", { text: 'your next property.', accent: true }],
  contactPageLead: 'To buy, rent, sell or ask for a reference price. Reach us through the channel you prefer.',
  channelWhatsapp: 'WhatsApp',
  channelPhone: 'Phone',
  channelEmail: 'Email',
  channelArea: 'Area',
  contactFormTitle: 'Tell us what you need',
  contactReason: 'Reason',
  reasonBuy: 'I want to buy',
  reasonRent: 'I want to rent',
  reasonSell: 'I want to sell',
  reasonAppraise: 'I want a reference price',
  contactSubmit: 'Send via WhatsApp',
  waContactIntro: 'Hi, I am {name}.',

  aboutTitle: 'About us',
  aboutIntro: 'We are two property advisors: we promote land and properties, answer every inquiry and support people with clear information and direct contact.',
  aboutRole: 'Property advisor',
  aboutCardOne: 'Specialist in property sourcing, reference prices and listing strategy.',
  aboutCardTwo: 'Specialist in inquiries, visits and support throughout the whole process.',
  aboutPageLines: ['Advisors', { text: 'with real names.', accent: true }],
  aboutTeamTitle: 'The team',

  footerStatement: 'Properties for sale and rent, with personal support from start to finish.',
  footerTagline: 'Advice to buy, rent and sell, with personal support.',
  footerBackTop: 'Back to top',
  footerCopy: 'FoxInmo. All rights reserved.',
  footerSectionExplore: 'Explore',
  footerSectionCompany: 'Company',
  footerSectionContact: 'Contact',
  footerAbout: 'About us',
  footerPrivacy: 'Privacy policy',
  footerTerms: 'Terms and conditions',
  footerBuyLink: 'Properties for sale',
  footerRentLink: 'Properties for rent',
  footerSell: 'Sell my property',
  footerShareTitle: 'Share',
  footerCity: 'Tucumán, Argentina',

  privacyTitle: 'Privacy policy',
  privacyIntro: 'At FoxInmo we protect your personal data and only use it to reply to property inquiries and improve assistance.',
  privacyDataTitle: 'Data we collect',
  privacyDataText: 'We may collect name, email, phone and message when you submit contact or selling forms.',
  privacyUseTitle: 'How we use information',
  privacyUseText: 'We use data to reply, schedule visits, send proposals and provide commercial follow-up.',
  privacyRightsTitle: 'Your rights',
  privacyRightsText: 'You can request updates or deletion of your data by sending us an email.',
  termsTitle: 'Terms and conditions',
  termsIntro: 'By using this website you accept the following terms for browsing, inquiries and listings.',
  termsScopeTitle: 'Service scope',
  termsScopeText: 'FoxInmo provides property advice and promotion and facilitates contact between the parties. It is not a real estate agency and does not provide brokerage services: each transaction is formalized directly between the parties, with the appropriate licensed professionals.',
  termsAccuracyTitle: 'Information accuracy',
  termsAccuracyText: 'We aim to keep data updated, though price, availability or conditions may change.',
  termsLiabilityTitle: 'Liability',
  termsLiabilityText: 'FoxInmo is not liable for decisions made without prior documentary verification by the parties.',
  legalUpdated: 'Legal information',

  seoHomeTitle: 'Land and properties for sale in Tucumán',
  seoHomeDescription: 'Land and plots for sale in Tucumán with measurements, utilities, price per m² and map location. Also houses and apartments. Direct contact with FoxInmo.',
  seoContactDescription: 'Contact FoxInmo on WhatsApp, by phone or email to buy, rent or sell your property.',

  publish: 'Publish',
  adminPanel: 'Admin panel',
  login: 'Sign in',
  invalidAdminKey: 'Invalid or missing ADMIN_KEY',
  invalidAdminCredentials: 'Invalid admin username or password',
  adminTitle: 'Admin panel',
  adminUsername: 'Admin user',
  adminPassword: 'Admin password',
  enterAdmin: 'Enter panel',
  adminSessionUser: 'Logged in as',
  logout: 'Log out',
  editProperty: 'Edit property',
  newProperty: 'New property',
  propertyTitle: 'Title',
  propertyDescription: 'Description',
  imageUrl: 'Main image URL',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  confirmDelete: 'Do you want to disable this property?',
  saveChanges: 'Save changes',
  createProperty: 'Create property',
  adminImageListHint: 'Photo URLs (one per line or comma separated)',
  adminImagePreviewTitle: 'Photo preview',
  adminMainImageTag: 'Main',
  adminImageTag: 'Photo',
  adminNoImagesPreview: 'Add image URLs to preview them before saving.',
  adminRoomsHint: 'Rooms: enter total number of rooms (example: 3 or 4).',
  adminAgeHint: 'Age: enter the approximate age in years.',
  adminUploadImages: 'Upload photos from your device',
  adminUploadingImages: 'Uploading images...',
  adminUploadError: 'Selected images could not be uploaded.',
  adminOptionalField: 'Optional field',
  adminGarageYes: 'With garage',
  adminGarageNo: 'Without garage',
  adminAmenitiesHint: 'Extra details or amenities (one per line or comma separated)',
  adminDetailsTitle: 'Property details',
  adminAddDetail: 'Add detail',
  adminDetailValue: 'Detail value (e.g. 80, 3, Yes, Balcony)',
  adminDetailType_SuperficieM2: 'total m²',
  adminDetailType_SuperficieCubiertaM2: 'covered m²',
  adminDetailType_Ambientes: 'rooms',
  adminDetailType_Dormitorios: 'bedrooms',
  adminDetailType_Banios: 'bathrooms',
  adminDetailType_Antiguedad: 'age (years)',
  adminDetailType_Cochera: 'garage (Yes/No)',
  adminDetailType_Amenidad: 'highlight detail',
  adminRemoveDetail: 'Remove',
  adminInquiriesTitle: 'Customer inquiries',
  adminInquiryProperty: 'Property',
  adminInquiryContact: 'Contact',
  adminInquiryMessage: 'Message',
  adminInquiryStatus: 'Status',
  adminInquiryDate: 'Date',
  adminNoInquiries: 'No inquiries yet.',
  adminFeaturedLabel: 'Feature on home page',
  adminFeaturedHint: 'Up to 4 featured: they lead the home page carousel and the last one you mark also fills the large block. With fewer than 4, the carousel is completed with the newest listings.',
  adminFeaturedTag: 'Featured',
  adminLandTitle: 'Land and utilities',
  adminFrente: 'Frontage (m)',
  adminFondo: 'Depth (m)',
  adminDeedNone: 'Title status: not specified',

  // El Molino del Churqui
  navProject: 'El Molino',
  projectBadge: 'Featured project',
  projectTagline: 'Investing in El Churqui means thinking long term.',
  projectSpotlightLead: 'Plots in Tafí del Valle, 5 minutes from the town centre, with 360° panoramic views and a direct link to the El Churqui sports trail.',
  projectCta: 'Discover the project',
  projectInquire: 'Ask about plots',
  projectViewPlan: 'View plot plan',
  projectBlocksLabel: 'blocks',
  projectLotSizesLabel: 'plot sizes',
  projectCenterLabel: 'to the town centre',
  projectViewsLabel: 'panoramic views',
  projectAreaRange: '{min} to {max} m²',
  projectAboutTitle: 'About the project',
  projectAboutText: 'El Molino del Churqui is a development in Tafí del Valle, Tucumán, designed for people who value comfort and want to connect with nature.',
  projectAboutText2: 'A place where modernity and tradition intertwine, and where exclusivity and a connection with the land come together as an excellent investment opportunity.',
  projectQuote: 'Dreaming is the first step. Owning it is the next.',
  projectHighlightsTitle: 'Why El Molino',
  projectHighlights: [
    { icon: 'clock', title: '5 minutes from the centre', text: 'A prime location, close to everything Tafí del Valle has to offer.' },
    { icon: 'mountain', title: '360° panoramic views', text: 'Open views of the mountains and the Tafí valley.' },
    { icon: 'asfalto', title: 'Via Route 307', text: 'Reached via Route 307, the road that climbs to Tafí del Valle from San Miguel de Tucumán.' },
    { icon: 'loop', title: 'El Churqui sports trail', text: 'Direct link to the trail, for outdoor sports.' },
    { icon: 'tree', title: 'Linear park', text: 'A linear park runs along the edge of the development.' },
    { icon: 'store', title: '“El Molino” shopping area', text: 'The development plan includes its own sector for a shopping area.' },
  ],
  projectLotsTitle: 'Plot plan',
  projectLotsLead: 'Tap a block to see its plot sizes and ask about availability. Colors show each sector.',
  projectSectors: {
    alto: 'Upper sector',
    central: 'Central sector',
    lateral: 'Side sector',
    comercial: 'Shopping area sector',
  },
  projectSoldLegend: 'Hatched plots: sold',
  projectBlock: 'Block {id}',
  projectBlockArea: 'Plots from {min} to {max} m²',
  projectBlockInquire: 'Ask',
  projectBlockAria: 'Block {id}, plots from {min} to {max} m²',
  projectLotsNote: 'Sizes as provided by the developer. Price and availability of each plot to be confirmed via WhatsApp.',
  projectVideosTitle: 'Project videos',
  projectVideosLead: 'Take a look around the site and see how the development\'s shopping area is planned.',
  projectVideos: {
    project: 'El Molino del Churqui in Tafí del Valle',
    commercial: '«El Molino» shopping area (illustrative project renders)',
  },
  projectGalleryTitle: 'Photos and plan',
  projectLocationTitle: 'Location',
  projectViewOnMaps: 'View on Google Maps',
  projectInstagram: 'Follow the project on Instagram',
  projectCtaLines: ['Interested in a plot', { text: 'at El Molino?', accent: true }],
  projectCtaLead: 'Message us and we will tell you which plots are still available, prices and how to arrange a visit to Tafí del Valle.',
  projectWaMessage: 'Hi, I would like information about the plots at El Molino del Churqui in Tafí del Valle.',
  projectWaBlockMessage: 'Hi, I would like to ask about the plots in Block {id} at El Molino del Churqui ({min} to {max} m²). What is available and at what price?',
  projectSeoTitle: 'El Molino del Churqui — Plots in Tafí del Valle',
  projectSeoDescription: 'Plots for sale at El Molino del Churqui, Tafí del Valle, Tucumán: 11 blocks, plots from 808 to 3,993 m², 5 minutes from the centre with 360° views. Ask via WhatsApp.',
};

export const messages = { es, en };

export function plural(count, one, other) {
  return (count === 1 ? one : other).replace('{n}', count);
}

export function fill(template, values) {
  return Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, value ?? ''),
    template
  );
}
